import React from "react";
import { Box, Card, Typography, Chip, Divider, Stack } from "@mui/material";
import styles from "./cisoDashboard.module.scss";

const zones = [
  { zone: "DMZ", status: "Healthy", assets: 34 },
  { zone: "Corporate Network", status: "Healthy", assets: 127 },
  { zone: "OT Production", status: "Warning", assets: 56 },
  { zone: "SCADA Systems", status: "Healthy", assets: 18 },
  { zone: "External Partners", status: "Critical", assets: 12 },
];

const statusColor = {
  Healthy: "#10b981",
  Warning: "#f59e0b",
  Critical: "#ef4444",
};

export const MicroSegmentationHealth = () => {
  return (
    <Card
      className={styles.card}
      sx={{ width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Typography className={styles.sectionHeading} fontWeight={600}>
        Micro-Segmentation Health
      </Typography>
      <Typography className={styles.subtitle} sx={{ mb: 1 }}>
        Zone security status
      </Typography>
      <Box className={styles.list}>
        {zones.map((zone) => (
          <Box
            key={zone.zone}
            className={styles.listItem}
            sx={{
              backgroundColor: "rgba(249, 250, 251, 1)",
              borderLeft: `5px solid ${statusColor[zone.status]}`,
            }}
          >
            <Box className={styles.listText} sx={{ pl: 2 }}>
              <Typography fontWeight={700}>{zone.zone}</Typography>
              <Typography className={styles.subtitle}>
                {zone.assets} assets
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <Divider />
      <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
        <Box>
          <Typography
            fontWeight={700}
            color={statusColor.Healthy}
            textAlign={"center"}
          >
            4
          </Typography>
          <Typography className={styles.subtitle}>Healthy</Typography>
        </Box>
        <Box>
          <Typography
            fontWeight={700}
            color={statusColor.Warning}
            textAlign={"center"}
          >
            1
          </Typography>
          <Typography className={styles.subtitle}>Warning</Typography>
        </Box>
        <Box>
          <Typography
            fontWeight={700}
            color={statusColor.Critical}
            textAlign={"center"}
          >
            1
          </Typography>
          <Typography className={styles.subtitle}>Critical</Typography>
        </Box>
      </Stack>
    </Card>
  );
};

export default MicroSegmentationHealth;
